<template>
  <section>
    <div class="col1">
      <h3 class="title">User</h3>

        <transition name="fade">
            <p v-if="showSuccess" class="has-text-primary">Perfil modificat</p>
        </transition>

      <form @submit.prevent>
        <label for="name">Name</label>
        <input v-model.trim="user.name" type="text" :placeholder="user.name" id="name" />

        <label for="name">role</label>        
        <div class="xselect">
        <select v-model="user.role" class="select">
          <option
            v-for="option in roles"
            :value="option.id"
            v-bind:key="option.id"
          >{{ option.description }}</option>
        </select>
        </div>
        
        

        <pre>{{ user }}</pre>

        <button @click="updateUser" class="button">Save</button>
      </form>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
const fb = require("../firebaseConfig.js");

export default {
  data() {
    return {
      showSuccess: false,
      userId: "",
      user: {},
      roles: [
        {
          id: 'user',
          description: "User"
        },
        {
          id: 'admin',
          description: "Admin"
        }
      ]
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"])
  },
  mounted() {
    if (this.userProfile.role !== 'admin') {
      this.$router.push('/')
    }
    
    if (this.$route.params.id) {
      this.userId = this.$route.params.id;
      this.viewUser();
    }
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      //console.log("to", to, from);
      if (this.$route.params.id) {
        this.userId = this.$route.params.id;
        this.viewUser();
      }
    }
  },
  created() {},
  methods: {
    viewUser() {
      fb.usersCollection
        .doc(this.userId)
        .get()
        .then(doc => {
          if (doc.exists) {
            let user = doc.data();
            user.id = doc.id;
            this.user = user;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    updateUser() {
      fb.usersCollection
        .doc(this.userId)
        .update({
          name: this.user.name,          
          role: this.user.role || 'user',
        })
        .then(doc => {
          this.showSuccess = true
          setTimeout(() => { this.showSuccess = false }, 2000)
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AdminUser.vue